import { createElement } from 'react';
import childrenArray from '../childrenArray';
/**
 * Map children with given function for prop modification.
 *
 * @param children Component children.
 * @param propHandler Function to handle prop modification.
 */
export const childrenPropsMap = (children, propHandler) =>
  childrenArray(children).map((child, index, array) =>
    createElement(
      child.type,
      Object.assign(
        Object.assign({ key: child.key }, child.props),
        propHandler(child, index, array)
      )
    )
  );
export default childrenPropsMap;
